<template>
	<header id="app-header">
		<!-- Дропдауны -->
		<AppHeaderNavDropdown
			sandwich
			label="Разделы"
			align="start"
			class="header-btn"
			material="grid_view"
			:items="REFS_ITEMS"
		>
			<template #default="{ query, close }">
				<VSearchPicker
					:query="query"
					:items="REFS_ITEMS"
					:favorites-key="REFS_FAVORITES_KEY"
					:default-favorites="REFS_DEFAULT_FAVORITES"
					@pick="onPick($event, close)"
				/>
			</template>
		</AppHeaderNavDropdown>

		<!-- Ссылки текущей роли -->
		<ul class="links">
			<li
				v-for="link in AppHeaderService.currentRole.items"
				:key="link.path + (link.hash ?? '')"
			>
				<router-link
          class="header-btn ellipsis"
          active-class=""
          exact-active-class=""
          :class="{ 'router-link-active': isLinkActive(link) }"
          :to="{ path: link.path, hash: link.hash }"
        >
					<VSvgIcon v-if="link.icon" :name="link.icon" class="icon"/>
					{{ link.label }}
				</router-link>
			</li>
		</ul>

		<!-- Действия справа -->
		<div class="actions">
			<router-link
        @mouseenter="$core.tooltip.show($event.currentTarget, timeZoneTooltip)"
        @mouseleave="$core.tooltip.hide()"
				type="button"
				class="header-btn"
				to="/profile/main"
			>
			 <span
				 :title="timeZoneTooltip"
				 :class="{ 'error': isClockSkewCritical }"
			 >
				{{ timeZoneStringRepresentation }}
			 </span>
			</router-link>

			<AppCurrencySelect
				class="header-btn"
			/>

			<AppHeaderPartnerProfile
				class="header-btn"
			/>
		</div>

	</header>
</template>

<style lang="scss" src="./AppHeader.scss"/>

<script lang="ts">
import AppHeaderService from '@/lib/components/AppHeader/AppHeaderService';
import type {NavRoute, NavGroup} from '@/lib/components/AppHeader/AppHeaderService';
import RpcService from '@/core/services/Rpc/RpcService';

const REFS_DEFAULT_FAVORITES: NavRoute[] = AppHeaderService.getStubDefaultFavorites();
const FUNNELS_GROUPS: NavGroup[] = AppHeaderService.getStubFunnels();
const FUNNELS_FLAT_ITEMS: NavRoute[] = FUNNELS_GROUPS.flatMap(group => group.items);

export default defineComponent({
	name: 'AppHeader',

	components: {},

  setup() {
    return {
      AppHeaderService
    }
  },

	data() {
    const REFS_ITEMS: NavRoute[] = AppHeaderService.getSubRefsForCurrentUser();

		return {
			REFS_ITEMS,
			REFS_DEFAULT_FAVORITES,
			REFS_FAVORITES_KEY: AppHeaderService.REFS_FAVORITES_STORAGE_KEY,
			FUNNELS_GROUPS,
			FUNNELS_FLAT_ITEMS,

			activeSubmenu: null as string | null,
		};
	},

	computed: {
		timeZoneStringRepresentation(): string {
			return this.$core.timeZone.toString();
		},

		clockSkewMs(): number {
			return RpcService.clockSkewMs.value;
		},

		isClockSkewCritical(): boolean {
			return Math.abs(this.clockSkewMs) >= 15 * 60_000; // 15 минут
		},

		clockSkewMinutes(): number {
			return Math.round(Math.abs(this.clockSkewMs) / 60_000);
		},

		timeZoneTooltip(): string {
			if (!this.isClockSkewCritical) {
				return this.timeZoneStringRepresentation;
			}

			return `Системные часы вашего компьютера расходятся с серверным временем на ${this.clockSkewMinutes} мин. Проверьте настройки времени.`;
		},
	},

	methods: {
		onPick(item: NavRoute, close: () => void): void {
			this.$router.push({path: item.path, hash: item.hash});
			close();
		},

		onPickGroup(group: NavGroup, close: () => void): void {
			AppHeaderService.setCurrentRoleLabel(group.label);
			close();
		},

		isLinkActive(link: NavRoute): boolean {
			/**
			 * Пункт активен если текущий URL это точно link.path
			 * или начинается с link.path + '/' (любой вложенный таб/секция)
			 */
			const pathMatches = this.$route.path === link.path
				|| this.$route.path.startsWith(link.path + '/');

			if (pathMatches === false) {
				return false;
			}

			if (link.hash !== undefined && link.hash !== null && link.hash.length > 0) {
				return this.$route.hash === link.hash;
			} else {
				return true;
			}
		},
	},
});
</script>
